import React from 'react';

import { AbilityIcon } from '@dndbeyond/character-components/es';
import { Ability, FormatUtils, HelperUtils } from '@dndbeyond/character-rules-engine/es';

interface Props extends Ability {
    bonusMinScore: number;
    bonusMaxScore: number;
    overrideMinScore: number;
    overrideMaxScore: number;
    onOtherBonusChange: (id: number, value: number | null) => void;
    onOverrideScoreChange: (id: number, value: number | null) => void;
}
interface State {
    overrideScore: number | null;
    otherBonus: number | null;
}
export default class AbilityScoreCalculations extends React.PureComponent<Props, State> {
    static defaultProps = {
        bonusMinScore: -10,
        bonusMaxScore: 10,
        overrideMinScore: 3,
        overrideMaxScore: 30,
    };

    constructor(props: Props) {
        super(props);

        this.state = {
            overrideScore: props.overrideScore,
            otherBonus: props.otherBonus,
        };
    }

    handleOtherBonusBlur = (evt: React.FocusEvent<HTMLInputElement>): void => {
        const { id, onOtherBonusChange, bonusMinScore, bonusMaxScore } = this.props;

        if (onOtherBonusChange) {
            const parsedValue = HelperUtils.parseInputInt(evt.target.value);
            let clampedValue: number | null = null;
            if (parsedValue !== null) {
                clampedValue = HelperUtils.clampInt(parsedValue, bonusMinScore, bonusMaxScore);
            }
            onOtherBonusChange(id, clampedValue);
            this.setState({
                otherBonus: clampedValue,
            });
        }
    };

    handleOtherBonusChange = (evt: React.ChangeEvent<HTMLInputElement>): void => {
        this.setState({
            otherBonus: HelperUtils.parseInputInt(evt.target.value),
        });
    };

    handleOverrideScoreBlur = (evt: React.FocusEvent<HTMLInputElement>): void => {
        const { id, onOverrideScoreChange, overrideMinScore, overrideMaxScore } = this.props;

        if (onOverrideScoreChange) {
            const parsedValue = HelperUtils.parseInputInt(evt.target.value);
            let clampedValue: number | null = null;
            if (parsedValue !== null) {
                clampedValue = HelperUtils.clampInt(parsedValue, overrideMinScore, overrideMaxScore);
            }
            onOverrideScoreChange(id, clampedValue);
            this.setState({
                overrideScore: clampedValue,
            });
        }
    };

    handleOverrideScoreChange = (evt: React.ChangeEvent<HTMLInputElement>): void => {
        this.setState({
            overrideScore: HelperUtils.parseInputInt(evt.target.value),
        });
    };

    render() {
        const { otherBonus, overrideScore } = this.state;
        const { label, totalScore, modifier, baseScore, racialBonus, classBonuses, miscBonus, setScore, statKey, id } =
            this.props;

        return (
            <div className={`ability-score-calc ability-score-calc-${statKey}`}>
                <div className="ability-score-calc-header">
                    <AbilityIcon statId={id} themeMode="light" className="ability-score-calc-icon" />
                    <div className="ability-score-calc-name">{label}</div>
                </div>
                <div className="ability-score-calc-components">
                    <div className="ability-score-calc-component">
                        <div className="ability-score-calc-component-label">Total Score</div>
                        <div className="ability-score-calc-component-value">
                            {totalScore === null ? '--' : totalScore}
                        </div>
                    </div>
                    <div className="ability-score-calc-component">
                        <div className="ability-score-calc-component-label">Modifier</div>
                        <div className="ability-score-calc-component-value">
                            {modifier === null ? '--' : FormatUtils.renderSignedNumber(modifier)}
                        </div>
                    </div>
                    <div className="ability-score-calc-component">
                        <div className="ability-score-calc-component-label">Base Score</div>
                        <div className="ability-score-calc-component-value">
                            {baseScore === null ? '--' : baseScore}
                        </div>
                    </div>
                    <div className="ability-score-calc-component">
                        <div className="ability-score-calc-component-label">Racial Bonus</div>
                        <div className="ability-score-calc-component-value">
                            {FormatUtils.renderSignedNumber(racialBonus)}
                        </div>
                    </div>
                    <div className="ability-score-calc-component">
                        <div className="ability-score-calc-component-label">Ability Improvements</div>
                        <div className="ability-score-calc-component-value">
                            {FormatUtils.renderSignedNumber(classBonuses)}
                        </div>
                    </div>
                    <div className="ability-score-calc-component">
                        <div className="ability-score-calc-component-label">Misc Bonus</div>
                        <div className="ability-score-calc-component-value">
                            {FormatUtils.renderSignedNumber(miscBonus)}
                        </div>
                    </div>
                    <div className="ability-score-calc-component">
                        <div className="ability-score-calc-component-label">Set Score</div>
                        <div className="ability-score-calc-component-value">{setScore}</div>
                    </div>
                </div>
                <div className="ability-score-calc-overrides">
                    <div className="ability-score-calc-override">
                        <div className="ability-score-calc-override-label">Other Modifier</div>
                        <div className="ability-score-calc-override-value">
                            <input
                                type="number"
                                value={otherBonus === null ? '' : otherBonus}
                                placeholder="--"
                                onChange={this.handleOtherBonusChange}
                                onBlur={this.handleOtherBonusBlur}
                            />
                        </div>
                    </div>
                    <div className="ability-score-calc-override">
                        <div className="ability-score-calc-override-label">Override Score</div>
                        <div className="ability-score-calc-override-value">
                            <input
                                type="number"
                                value={overrideScore === null ? '' : overrideScore}
                                placeholder="--"
                                onChange={this.handleOverrideScoreChange}
                                onBlur={this.handleOverrideScoreBlur}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
